//로그인, 회원가입 상태 조회
import { useSelector } from 'react-redux';
import { RootState } from '../../modules';

export default function useStatus() {
  const status = useSelector((state: RootState) => state.auth);
  return status;
}
